import React from 'react';
import './Presentation.css';

export default function Presentation() {
  return (
    <section className="presentation">
      <h2>Présentation</h2>

      <div className="presentation-content">
        <div className="presentation-image">
          <img src={require('../../assets/images/presentation.png')} alt="Présentation Nexus Solutions" />
        </div>
        <div className="presentation-text">
          <p>
            Nexus Solutions accompagne la transformation numérique des organisations en concevant des
            produits et services digitaux sur mesure, pensés pour répondre à des enjeux métiers réels.
            Nous combinons stratégie, design et expertise technique afin de livrer des solutions robustes,
            sécurisées et faciles à maintenir. Notre méthode privilégie le dialogue et l'itération : ateliers
            de cadrage, prototypes rapides et retours utilisateurs réguliers permettent d'ajuster la trajectoire
            en continu et de maximiser la valeur livrée.
          </p>

          <p>
            Notre équipe pluridisciplinaire — chefs de projet, designers, développeurs et ingénieurs cloud —
            travaille en étroite collaboration avec les équipes clientes pour transformer des besoins
            complexes en produits exploitables. Nous maîtrisons les bonnes pratiques (tests automatisés,
            revues de code, CI/CD) et intégrons la sécurité et l'efficience dès la conception. Nous favorisons
            des partenariats durables, fondés sur la transparence et des objectifs mesurables.
          </p>

          <p>
            Si vous souhaitez lancer un projet, explorer des prototypes ou organiser un atelier de cadrage,
            contactez‑nous : nous serons ravis de définir ensemble une feuille de route pragmatique,
            priorisée et alignée sur vos résultats attendus.
          </p>
        </div>
      </div>
    </section>
  );
}
